import { commonjsGlobal as n } from "./index61.js";
import { __exports as T } from "./index147.js";
import m from "react";
import { c as s } from "./index167.js";
(function(e) {
  var o = n && n.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = u, e.setStyleProp = l;
  var i = m, a = o(s), f = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function u(t, r) {
    return t.includes("-") ? !f.has(t) : !!(r && typeof r.is == "string");
  }
  var _ = {
    reactCompat: !0
  };
  function l(t, r) {
    if (typeof t == "string") {
      if (!t.trim()) {
        r.style = {};
        return;
      }
      try {
        r.style = (0, a.default)(t, _);
      } catch {
        r.style = {};
      }
    }
  }
  e.PRESERVE_CUSTOM_ATTRIBUTES = Number(i.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var E = function(t) {
    return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(t.name);
  };
  e.canTextBeChildOfNode = E;
  var c = function(t) {
    return t;
  };
  e.returnFirstArg = c;
})(T);
